import { render, staticRenderFns } from "./GiftPage.vue?vue&type=template&id=5ccfef0c&scoped=true&"
var script = {}
import style0 from "./GiftPage.vue?vue&type=style&index=0&id=5ccfef0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccfef0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
